import { combineReducers } from 'redux'
import * as t from './actionTypes'

const initLoginStatus = {
  status: '',
  transferred: false,
  msg: ''
}

export const getMsgFromError = (action) => {
  let msg
  try {
    msg = action.payload.response.data.msg
  } catch (e) {
    msg = 'Error'
  }
  return msg
}

export const loginStatus = (state = initLoginStatus, action) => {
  switch (action.type) {
    case t.SET_LOGIN_STATUS:
      return action.payload
    case t.LOGOUT:
      return initLoginStatus
    case t.LOGIN_SUCCESS:
    case t.SET_PASS_SUCCESS:
    case t.PASS_RESET_SUCCESS:
    case t.SIGNUP_SUCCESS:
      return {status: 'ok', msg: action.payload.msg, transferred: action.payload.transferred}
    case t.LOGIN_ERROR:
    case t.SIGNUP_ERROR:
      return {status: 'bad', msg: getMsgFromError(action), transferred: false}
    default:
      return state
  }
}

const initStatus = () => ({status: '', msg: ''})

export const signupStatus = (state = initStatus(), action) => {
  switch (action.type) {
    case t.SET_SIGNUP_STATUS:
      return action.payload
    case t.LOGOUT:
      return initStatus()
    case t.SET_PASS_SUCCESS:
    case t.SIGNUP_SUCCESS:
      let msg = 'Please check your inbox for the email we sent and click the link to activate your account.'
      if (action.payload.location) {
        msg = ''
      } else {
        msg = action.payload.msg
      }
      return {status: 'ok', msg}
    case t.SET_PASS_ERROR:
    case t.SIGNUP_ERROR:
      return {status: 'bad', msg: action.payload.msg || getMsgFromError(action)}
    default:
      return state
  }
}

export const passwordResetStatus = (state = initStatus(), action) => {
  switch (action.type) {
    case t.SET_PASSWORD_RESET_STATUS:
      return action.payload
    case t.LOGOUT:
      return initStatus()
    case t.REQUEST_RESET_SUCCESS:
    case t.PASS_RESET_SUCCESS:
      return {status: 'ok', msg: action.payload.msg}
    case t.REQUEST_RESET_ERROR:
    case t.PASS_RESET_ERROR:
      return {status: 'bad', msg: getMsgFromError(action)}
    default:
      return state
  }
}

export const logoutStatus = (state = initStatus(), action) => {
  switch (action.type) {
    case t.SET_LOGOUT_STATUS:
      return action.payload
    case t.LOGOUT:
      return initStatus()
    default:
      return state
  }
}

const status = combineReducers({
  login: loginStatus,
  signup: signupStatus,
  reset: passwordResetStatus,
  logout: logoutStatus
})

export {status as default}



// WEBPACK FOOTER //
// ./assets/auth/status.js